/** @file The world offset (no depth) that moves a point by a screen delta in px. */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import type { View } from '@zilo/pose3d-render-core/camera/viewOf';

/** One inverse per view kind; a new kind is a type error until it has an entry (15.11). */
const BY_KIND: { [K in View['kind']]: (dx: number, dy: number, view: Extract<View, { kind: K }>) => Vec3 } = {
  ortho: (dx, dy, view) => {
    const { right, up } = view.basis;
    const a = dx / view.pixelsPerUnit;
    const b = dy / view.pixelsPerUnit;
    return [right[0] * a - up[0] * b, right[1] * a - up[1] * b, (right[2] * a - up[2] * b) / view.zScaleView];
  },
};

/** `right dx / ppu - up dy / ppu`, z divided by `zScaleView`; perpendicular to the view direction. */
export function screenDeltaToWorld(dx: number, dy: number, view: View): Vec3 {
  return BY_KIND[view.kind](dx, dy, view);
}
